import FormDialog from "../../../../components/dialog/form/FormDialog.vue";
import CargoService from "../../../../services/CargoService.js";
import { AssinaturaMixin } from "@/mixins/assinaturaMixin";
import { SnackbarMixin } from "@/mixins/snackbarMixin";
import {SnackBarModule} from "@/modules/SnackBarModule";
import TextField from "../../../../components/fields/textField/TextField.vue";

export default {
    name:"DialogCargosUsuario",
    mixins:[AssinaturaMixin,SnackbarMixin ],
    components:{
        FormDialog,
        SnackBarModule,
        CargoService,
        TextField
    },
    props: {
        activeDialog: {
            type: Boolean,
            default: false,
        },
        usuarioid:{
            required: true,
        }
    },
    data: () => ({
        showFormDialog: false,
        activeBtnDialog:false,
        tableCargos: [
            { text: "Cargo", value: "nome", sortable: false },
            { text: "", value: "atribuir", sortable: false, width: "100" },
        ],
        data: [],
        errors: [],
        disabled: {
            nome: false,
            cargos: false,
        },
        form: {},
        formValid: true,
        loading: {
            table: false,
            table_cargos:false,
            btnsave:false,
            btn:{
                save:false
            }
        },
        page: 1,
        pageCount: 0,
        itemsPerPage: 10,
        search: "",
        showDialogConfirmPassword: false,
        formConfirmPassword: {
            justificativa:"",
            password:""
        },
        send: {
            function: () => {},
            params: null,
        },

        cargos: [],
    }),
    watch: {
        activeDialog() {

                if(this.usuarioid) {

                    this.showFormDialog = !this.showFormDialog;
                    this.initializeForm();
                    this.getEditData();
                }


        },
    },
    created() {
        this.initializeForm();
        this.getCargos();
    },
    methods: {
        testDrive() {
            
        },
        async getEditData() {
            this.page = 1;

            this.disabled.cargos = true;
            const response = CargoService.getCargosUsuarios(
                this.usuarioid
            );

            response.then((res) => {

                this.form.cargo_id = res.content.response.map(
                    (cargo) => cargo.cargo_id,
                );

                this.form.arrayCargos = this.form.cargo_id.slice();

                this.disabled.cargos = false;
            })


        },
        updateCargosSave() {
            this.loading.btnsave = true;
            //verficar se tem ao menos 1
            const response = CargoService.getCargosUsuarios(
                this.usuarioid
            );

            response.then((res) => {
                if(res.content.response.length == 0) {
                    SnackBarModule("Você deve atribuir ao menos 1 cargo para esse usuário","error")

                } else {
                    this.showFormDialog = !this.showFormDialog;
                }
                this.loading.btnsave = false;
            })
            //
            this.$emit("update");

        },
         async selectCargoUser(cargo) {
             this.loading.table = true;

            //this.form =


           const ret = await CargoService.addCargoUser({
               cargo_id:cargo,
               id_pessoa:this.usuarioid
           })
             ret.message.then((res) => {
                 //this.$root.$on('getUsers');
                 SnackBarModule(res.response,"success")
                 this.loading.table = false;
             })
        },
        initializeForm() {
            this.form = {
                cargo_id: [],
                arrayCargos: [],
            };
        },
        async getCargos() {

            this.disabled.cargos = true;
            const response = CargoService.getCargos();
            response.then((res) => {
                this.disabled.cargos = false;
                this.cargos = res.content.response;
            })


        },
    }
}